import mitt from 'mitt'

var EventBus = mitt()

export default EventBus
